if (!customElements.get('superu-purchase-story')) {
  customElements.define('superu-purchase-story', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.shopify-section') || this.parentElement;
      this.pricing = JSON.parse(this.querySelector('[data-su-pricing]').textContent);
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.renderDetails());
      };
      this.root.addEventListener('change', this.refresh);
      this.root.addEventListener('variant:update', this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.root, {childList:true,subtree:true,attributes:true,attributeFilter:['class','checked']});
      this.renderDetails();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('change',this.refresh);
      this.root?.removeEventListener('variant:update',this.refresh);
      cancelAnimationFrame(this.frame);
    }
    renderDetails() {
      const picker = this.root.querySelector('variant-picker input[data-variant-id]:checked');
      const id = picker?.dataset.variantId || this.dataset.initialVariant;
      this.querySelectorAll('[data-su-drink]').forEach(img => {
        const hidden = img.dataset.suDrink !== id;
        if (img.hidden !== hidden) img.hidden = hidden;
      });
      this.root.querySelectorAll('.shopify_subscriptions_app_container[data-product-id="8284934013244"] .shopify_subscriptions_app_block').forEach(section => {
        const variant = this.pricing[section.dataset.variantId];
        if (!variant) return;
        section.querySelectorAll('input[data-radio-type]').forEach(input => {
          const detail = input.dataset.radioType === 'one_time_purchase' ? variant.oneTime : variant.plans[input.dataset.sellingPlanId];
          const label = input.closest('label');
          const price = label?.querySelector('.in_widget_price');
          if (!price || !detail) return;
          if (!price.classList.contains('su-purchase-price')) price.classList.add('su-purchase-price');
          if (price.getAttribute('aria-hidden') === 'true') price.removeAttribute('aria-hidden');
          let small = price.querySelector('.su-serving-detail');
          if (!small) {
            small = document.createElement('small');
            small.className = 'su-serving-detail';
            price.append(small);
          }
          if (small.textContent !== detail) small.textContent = detail;
          if (input.dataset.radioType === 'selling_plan') {
            const title = label.querySelector('.title_and_price_wrapper > span');
            if (title) {
              const current = title.textContent.trim();
              const cleaned = current.replace(/,\s*\$[\d,.]+(?:\s*USD)?\s*$/, '');
              if (current !== cleaned) title.textContent = cleaned;
            }
          }
        });
      });
    }
  });
}
